import React, { ChangeEvent, InputHTMLAttributes, useCallback } from 'react';
import { applyComponentTheme } from '../../../theme';
import InputSpinner from '../InputSpinner';
import InputUnderline from '../InputUnderline';
import { InputComponent } from '../inputTypes';
import { Container, StyledInput, StyledInputMask } from './styles';

const NUMERIC_REGEX = /^[\d]*$/;

export type TextInputProps = {
  id: string;
  numbersOnly?: boolean;
  prefix?: string;
  value?: string;
  loading?: boolean;
  mask?: string;
} & InputHTMLAttributes<HTMLInputElement>;

const Input: InputComponent<TextInputProps> = ({
  className,
  numbersOnly,
  onChange,
  prefix,
  value,
  loading,
  mask,
  ...rest
}) => {
  const onChangeCb = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        if (!numbersOnly || event.target.value.match(NUMERIC_REGEX)) {
          onChange(event);
        }
      }
    },
    [numbersOnly, onChange]
  );

  const inputProps: InputHTMLAttributes<HTMLInputElement> = {
    onChange: onChangeCb,
    prefix,
    type: 'text',
    value,
    inputMode: numbersOnly ? 'numeric' : 'text',
    ...rest,
  };

  return (
    <Container className={className} prefix={prefix}>
      {mask ? (
        <StyledInputMask mask={mask} maskChar={null} {...inputProps} />
      ) : (
        <StyledInput {...inputProps} />
      )}
      {loading && <InputSpinner />}
      <InputUnderline />
    </Container>
  );
};

export default applyComponentTheme(Input, 'TextInput');
